import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
export const AcNumberInput = forwardRef(function AcNumberInput(props, ref) {
    if (props.editable === true) {
        return renderEditable(props, ref);
    }
    return renderRead(props);
});
function renderRead(p) {
    const formatted = p.formatValue ? p.formatValue(p.value) : String(p.value);
    const baseClass = 'ac-number-input';
    const className = p.className ? `${baseClass} ${p.className}` : baseClass;
    return (_jsxs("span", { className: className, "aria-label": p.ariaLabel, "data-testid": p.dataTestId, children: [_jsx("span", { className: "ac-number-input__value", children: formatted }), p.unit !== undefined ? _jsx("span", { className: "ac-number-input__unit", children: p.unit }) : null] }));
}
function renderEditable(p, ref) {
    const formatted = p.formatValue ? p.formatValue(p.value) : String(p.value);
    const baseClass = 'ac-number-input ac-number-input--editable';
    const className = p.className ? `${baseClass} ${p.className}` : baseClass;
    const handleChange = (event) => {
        const raw = event.target.value;
        if (raw === '') {
            return;
        }
        const parsed = Number(raw);
        if (Number.isNaN(parsed)) {
            return;
        }
        // Clamp to min/max BEFORE invoking onChange. Browsers only enforce
        // <input min max> on form submit, not on typed input — so without this
        // clamp, typing "200" into a 0..127 slider would call onChange(200) and
        // either throw at the device boundary (S-330 strict clamp) or produce
        // a visible/device disagreement (S-550 silently clamps). Same for "-5"
        // on a 0..127 control. The clamp guarantees the device sees what the
        // user sees, regardless of typed input.
        const lo = p.min;
        const hi = p.max;
        let clamped = parsed;
        if (lo !== undefined && clamped < lo)
            clamped = lo;
        if (hi !== undefined && clamped > hi)
            clamped = hi;
        p.onChange(clamped);
    };
    return (_jsxs("span", { className: className, children: [_jsx("input", { ref: ref, type: "number", className: "ac-number-input__value", value: formatted, onChange: handleChange, min: p.min, max: p.max, step: p.step ?? 1, disabled: p.disabled, "aria-label": p.ariaLabel, "data-testid": p.dataTestId }), p.unit !== undefined ? _jsx("span", { className: "ac-number-input__unit", children: p.unit }) : null] }));
}
//# sourceMappingURL=AcNumberInput.js.map